import { NgModule } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Data, RouterModule, Routes } from '@angular/router';

export interface RouteData extends Data {
  title?: string;
  hideMenu?: boolean;
  hideProfileSection?: boolean;
  disableLinkOnPlLogo?: boolean;
  handleScrollWithinComponent?: boolean;
}

export const mergeAllChildRouteData = (activatedRoute: ActivatedRoute): RouteData => {
  let routeDataMerged: RouteData = activatedRoute.snapshot.data;

  let routeChild: ActivatedRouteSnapshot | null = activatedRoute.snapshot.firstChild;
  while (routeChild) {
    if (routeChild.data) {
      routeDataMerged = {
        ...routeDataMerged,
        ...routeChild.data,
      };
    }

    routeChild = routeChild.firstChild;
  }

  return routeDataMerged;
};

const routes: Routes = [
  // Fallback when no prior route is matched
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
